<h2 mat-dialog-title>Alteração de status</h2>

<mat-dialog-content class="content">
  <div class="tag-container">
    <span>Você está movendo o lead de</span>
    <span class="tag" [ngClass]="data.previousStatus">{{ data.previousStatus | leadStatus }}</span>
    <span>para</span>
    <span class="tag" [ngClass]="data.currentStatus">{{ data.currentStatus | leadStatus }}</span>
  </div>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Observação (opcional)</mat-label>
    <input matInput [(ngModel)]="note" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Desfazer</button>

  <button mat-raised-button class="confirm" (click)="confirm()">Confirmar</button>
</mat-dialog-actions>
